import { RecommendedTariffConfig, SponsoredTariffData } from 'projectSections/sections/energy/ElectricityUtility/tariffShowcase/types'
import { createSelector } from 'reselect'

export interface SponsoredTariffsState {
  tariffCodes: string[]
  hydratedTariffs: RecommendedTariffConfig[]
  projectZip: string | null
  loading: boolean
}

const initialState: SponsoredTariffsState = {
  tariffCodes: [],
  hydratedTariffs: [],
  projectZip: null,
  loading: false,
}

export const SET_SPONSORED_TARIFF_DATA = 'SET_SPONSORED_TARIFF_DATA'
export const CLEAR_SPONSORED_TARIFF_CODES = 'CLEAR_SPONSORED_TARIFF_CODES'

export const clearSponsoredTariffCodes = () => ({
  type: CLEAR_SPONSORED_TARIFF_CODES,
})

export default function sponsoredTariffsReducer(
  state: SponsoredTariffsState = initialState,
  action: any
): SponsoredTariffsState {
  switch (action.type) {
    case SET_SPONSORED_TARIFF_DATA:
      return {
        tariffCodes: action.payload.tariffCodes || [],
        hydratedTariffs: action.payload.hydratedTariffs || [],
        projectZip: action.payload.projectZip || null,
        loading: action.payload.loading || false,
      }
    case CLEAR_SPONSORED_TARIFF_CODES:
      return initialState
    default:
      return state
  }
}

// Base selectors - these return raw data from state
const getTariffCodesRaw = (state: any): string[] => {
  return state.sponsoredTariffs?.tariffCodes || []
}

const getHydratedTariffsRaw = (state: any): RecommendedTariffConfig[] => {
  return state.sponsoredTariffs?.hydratedTariffs || []
}

const getProjectZipRaw = (state: any): string | null => {
  return state.sponsoredTariffs?.projectZip || null
}

const isLoadingRaw = (state: any): boolean => {
  return state.sponsoredTariffs?.loading || false
}

const getSponsoredTariffDataMemoized = createSelector(
  [getTariffCodesRaw, getHydratedTariffsRaw, isLoadingRaw],
  (tariffCodes, hydratedTariffs, loading): SponsoredTariffData => ({
    sponsoredTariffCodes: tariffCodes,
    hydratedTariffs: hydratedTariffs,
    loading: loading,
  })
)

export const sponsoredTariffsSelectors = {
  getTariffCodes: getTariffCodesRaw,
  getHydratedTariffs: getHydratedTariffsRaw,
  getProjectZip: getProjectZipRaw,
  isLoading: isLoadingRaw,
  getSponsoredTariffData: getSponsoredTariffDataMemoized,
}
